import logger from '@cash-web/shared/util-logger'

import { internalRouteHandlers } from './routes'
import { InternalRouteMatch, RouteInfo } from './types'

export const redirect = ({
  app,
  url,
  target,
  journeyFallback = true,
}: {
  app?: 'support' | 'account'
  url: string
  target: string
  journeyFallback?: boolean
}): RouteInfo => {
  const currentApp = typeof window !== 'undefined' ? window.location.pathname.split('/')[1] : ''
  const type = app === currentApp ? 'internal' : 'external'
  const pathWithAppName = `/${app}${url}`

  return {
    type,
    url: type === 'internal' || !app ? url : pathWithAppName,
    redirect: (targetOverride?: string) => {
      window.open(app ? pathWithAppName : url, targetOverride ?? target)
    },
    ...(type === 'internal' ? { journeyFallback } : {}),
  }
}

export const matchUrl = (url: string, match: InternalRouteMatch) => {
  return match instanceof RegExp ? match.test(url) : url === match
}

export const getSupportedInternalRouteInfo = (url: string): RouteInfo | undefined => {
  for (const routeAction of internalRouteHandlers) {
    const match = routeAction.match.find(m => {
      const matchedUrl = matchUrl(url, m)
      const canWeMatch = routeAction.when ? routeAction.when() : true
      return matchedUrl && canWeMatch
    })

    if (match) {
      return routeAction.handler(url, match)
    }
  }
  return undefined
}

const ACCOUNT_AWARE_ROUTING_PARAMETERS = ['accountPid', 'account_requirement']
export const removeAccountAwareRoutingParams = (originalUrl: string) => {
  let url: URL

  try {
    url = new URL(originalUrl)
  } catch (e) {
    logger.error(e as Error)

    return originalUrl
  }

  if ([...url.searchParams].length === 0) {
    return originalUrl
  }

  ACCOUNT_AWARE_ROUTING_PARAMETERS.forEach(param => {
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param)

      logger.warn(new Error(`Removed account aware routing parameter ${param} from url ${originalUrl}.`))
    }
  })

  return url.toString()
}
